var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(frame,index){return _c('img',{key:frame.image.id + index,staticClass:"image",class:[ frame.position ],attrs:{"src":'/media/' + frame.image.id}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }